import { Box, BoxProps, Text, TextProps } from "@chakra-ui/react";

export const HeaderText: React.FC<TextProps> = (props) => (
  <Text fontSize="26px" mb={2} {...props} />
);
export const SubHeaderText: React.FC<TextProps> = (props) => (
  <Text fontSize="22px" mb={2} {...props} />
);
export const Information: React.FC<TextProps> = (props) => (
  <Text fontSize="16px" mb={6} {...props} />
);
export const Address: React.FC<TextProps> = (props) => <Text fontSize="16px" {...props} />;
export const AddressBlock: React.FC<BoxProps> = (props) => <Box mb={4} {...props} />;
